let contractTypesForEmployee = [
  { value: "CDD", label: "CDD" },
  { value: "CDI", label: "CDI" },
  { value: "INTERNSHIP", label: "Stage" },
  { value: "TRIAL_CONTRACT", label: "Contrat d'essai" },
  { value: "NONE", label: "Aucun" },
];

export default contractTypesForEmployee;
